import React from "react";

import { Button, Menu, MenuItem, Typography } from "@material-ui/core";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import { withStyles } from "@material-ui/core/styles";

import Spacer from "components/Spacer";

import { useAppDispatch, useAppSelector } from "store";
import { selectUserInfo } from "modules/auth/authSlice";
import {
    selectRangesSort,
    setRangesSort,
    RangesSortField
} from "modules/customer/tools/product/storeRangeFilters/storeRangeFiltersSlice";
import { SortDirection } from "utils/sortUtils";

const StyledMenu = withStyles(theme => ({
    list: {
        width: theme.spacing(25)
    }
}))(Menu);

const StyledMenuItem = withStyles(theme => ({
    root: {
        fontWeight: (props: any) => props["data-current"] ? "bold" : "normal",
        color: (props: any) => props["data-current"] ? theme.palette.text.primary : theme.palette.text.disabled
    }
}))(MenuItem);

const Sort: React.FC = () => {
    const dispatch = useAppDispatch();
    const clientName = useAppSelector(selectUserInfo).companyDisplayName;
    const rangesSort = useAppSelector(selectRangesSort);
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSortClick = (field: RangesSortField) => () => {
        let direction = SortDirection.ASC;
        if (rangesSort.field === field) {
            direction = rangesSort.direction === SortDirection.ASC ? SortDirection.DESC : SortDirection.ASC;
        }
        const newRangesSort = { ...rangesSort, field, direction };
        dispatch(setRangesSort(newRangesSort));
    };

    return (
        <>
            <Button
                variant="text"
                size="small"
                color="default"
                disableElevation
                startIcon={<ArrowDownwardIcon />}
                onClick={handleClick}
                data-cy="btn-sort"
            >
                Sort
            </Button>
            <StyledMenu
                open={open}
                onClose={handleClose}
                variant="menu"
                keepMounted
                anchorEl={anchorEl}
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right"
                }}
            >
                <StyledMenuItem onClick={handleSortClick(RangesSortField.RangeName)} data-current={rangesSort.field === RangesSortField.RangeName}>
                    <Typography variant="body1" component="div">
                        Range name
                    </Typography>
                    <Spacer />
                    {rangesSort.field !== RangesSortField.RangeName || rangesSort.direction === SortDirection.ASC ? (
                        <ArrowUpwardIcon fontSize="small" />
                    ) : (
                        <ArrowDownwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSortClick(RangesSortField.Headroom)} data-current={rangesSort.field === RangesSortField.Headroom}>
                    <Typography variant="body1" component="div">
                        Headroom
                    </Typography>
                    <Spacer />
                    {rangesSort.field !== RangesSortField.Headroom || rangesSort.direction === SortDirection.ASC ? (
                        <ArrowUpwardIcon fontSize="small" />
                    ) : (
                        <ArrowDownwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSortClick(RangesSortField.OptimisedSales)} data-current={rangesSort.field === RangesSortField.OptimisedSales}>
                    <Typography variant="body1" component="div">
                        Optimised sales
                    </Typography>
                    <Spacer />
                    {rangesSort.field !== RangesSortField.OptimisedSales || rangesSort.direction === SortDirection.ASC ? (
                        <ArrowUpwardIcon fontSize="small" />
                    ) : (
                        <ArrowDownwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSortClick(RangesSortField.TotalEstimatedSales)} data-current={rangesSort.field === RangesSortField.TotalEstimatedSales}>
                    <Typography variant="body1" component="div">
                        Estimated sales
                    </Typography>
                    <Spacer />
                    {rangesSort.field !== RangesSortField.TotalEstimatedSales || rangesSort.direction === SortDirection.ASC ? (
                        <ArrowUpwardIcon fontSize="small" />
                    ) : (
                        <ArrowDownwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSortClick(RangesSortField.ClientSourcedSales)} data-current={rangesSort.field === RangesSortField.ClientSourcedSales}>
                    <Typography variant="body1" component="div">
                        {clientName} sourced sales
                    </Typography>
                    <Spacer />
                    {rangesSort.field !== RangesSortField.ClientSourcedSales || rangesSort.direction === SortDirection.ASC ? (
                        <ArrowUpwardIcon fontSize="small" />
                    ) : (
                        <ArrowDownwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
            </StyledMenu>
        </>
    );
};

export default Sort;
